/* PADUA WEDDINGS - MIXED MEDIA COLLECTION 
A blend of high-end photography and cinematic video captures. */
export const galleryImages = [
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Jae-Mhin-&-Colin.jpg?updatedAt=1782323354559",
    alt: "Jae-Mhin & Colin at Padua Weddings",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0526%20(1).mov/ik-video.mp4?updatedAt=1781381310944",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0526%20(1).mov/ik-thumbnail.jpg",
    alt: "Padua Cinematic Moment 1",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0618(1).mov",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0618(1).mov/ik-thumbnail.jpg",
    alt: "Padua Cinematic Moment 3",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0606%20(1).mov/ik-video.mp4?updatedAt=1781380963578",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0606%20(1).mov/ik-thumbnail.jpg",
    alt: "Padua Cinematic Moment 2",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/220609_W_Newmann-0496.jpg?updatedAt=1782332279083",
    alt: "Wedding Portrait",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0615%20(2)(1).mov",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0615%20(2)(1).mov/ik-thumbnail.jpg",
    alt: "Padua Cinematic Moment 4",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/SavannahLance_Wedding-17.jpg?updatedAt=1782332252605",
    alt: "Savannah & Lance",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0520(5).mov/ik-video.mp4?updatedAt=1781381286449",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0520(5).mov/ik-thumbnail.jpg",
    alt: "Ceremony Detail Video",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0622(1).mov",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0622(1).mov/ik-thumbnail.jpg",
    alt: "Padua Cinematic Moment 5",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/Liana%20&%20John%20We-426.jpg?updatedAt=1782332240997",
    alt: "Liana & John",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0508%20(1).mov/ik-video.mp4?updatedAt=1781381093797",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0508%20(1).mov/ik-thumbnail.jpg",
    alt: "Evening Atmosphere",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0518(1).mov",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0518(1).mov/ik-thumbnail.jpg",
    alt: "Padua Cinematic Moment 6",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/2214840.jpg?updatedAt=1782332201268",
    alt: "Architecture Detail",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0516(1).mov/ik-video.mp4?updatedAt=1781381204299",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0516(1).mov/ik-thumbnail.jpg",
    alt: "Golden Hour Video",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0518(6).mov",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0518(6).mov/ik-thumbnail.jpg",
    alt: "Padua Cinematic Moment 7",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/R14.jpg?updatedAt=1782332185643",
    alt: "Table Details",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/R8.jpg?updatedAt=1782332185006",
    alt: "Bridal Suite",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0617(6).mov",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0617(6).mov/ik-thumbnail.jpg",
    alt: "Padua Cinematic Moment 8",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0520.mov/ik-video.mp4?updatedAt=1781381216567",
    poster: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0520.mov/ik-thumbnail.jpg",
    alt: "Reception Energy",
    type: "video"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/R12.jpg?updatedAt=1782332183295",
    alt: "Outdoor Ceremony",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/IMG_0587.jpg?updatedAt=1782332185048",
    alt: "Candlelit Detail",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/R13.jpg?updatedAt=1782332183818",
    alt: "Estate Garden",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/R9.jpg?updatedAt=1782332180275",
    alt: "Floral Design",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/0450-RM-Pauda-Hills-Theatre-Los-Angeles-County-Wedding-Photography.jpg-nggid041174-ngg0dyn-0x1000-00f0w010c010r110f110r010t010.jpg?updatedAt=1782332175943",
    alt: "Historic Theatre View",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/295857433_10223639648793285_5226934492308009854_n.jpg?updatedAt=1782332174713",
    alt: "Happy Couple",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/295818992_10223639644033166_5285952606979641035_n.jpg?updatedAt=1782332174999",
    alt: "First Dance",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/R3.jpg?updatedAt=1782332173478",
    alt: "Courtyard View",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/IMG_0211.jpg?updatedAt=1782332186597",
    alt: "Evening Light",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/Padua-Hills-Wedding-Christina-and-Chris-99.jpg?updatedAt=1782332189836",
    alt: "Christina & Chris",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/26-BBR63438.jpg?updatedAt=1782332192438",
    alt: "Detail Shot",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Gallery/SavannahLance_Wedding-56.jpg?updatedAt=1782332279834",
    alt: "Savannah & Lance",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Lauren-and-DJ-91.jpg?updatedAt=1776897467348",
    alt: "Lauren & DJ",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/33-Padua-Hills-Theatre-Claremont-Rainy-Wedding-Photography.jpg?updatedAt=1776890012752",
    alt: "Rainy Wedding",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/17-padua-hills-claremont-wedding-photography.jpg?updatedAt=1776889995408",
    alt: "Classic Padua View",
    type: "image"
  },
  {
    src: "https://ik.imagekit.io/aeu02xvjgn/IMG_1387.JPG?updatedAt=1776890007910",
    alt: "Celebration Moment",
    type: "image"
  }
];